var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maskConstain"},[_c('div',{staticClass:"anim"},[_vm._v("用户ID:"+_vm._s(_vm.getWaterMark))])])}
var staticRenderFns = []

export { render, staticRenderFns }